import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropTillagesByPrimaryDataId, setFootprintingCropTillagesByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP, FOOTPRINTING_CROP_TILLAGES } from "consts";

import { FootprintingCropTillage } from "models";

export const useMutateFootprintingCropTillages = (
  farmId: string,
  cropId: string,
  year: number,
  payload: Array<FootprintingCropTillage>,
  primaryDataId: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropTillagesByPrimaryDataIdAdmin : setFootprintingCropTillagesByPrimaryDataId;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_TILLAGES, primaryDataId],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_CROP_TILLAGES, primaryDataId],
          [FOOTPRINTING_CROP, farmId, cropId, year],
          [FOOTPRINTING_CROP, primaryDataId, isAdmin],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
